
define("all", function(){});
